import React from 'react';
import { withStyles } from 'material-ui/styles';
import { withRouter } from "react-router-dom";
import UIApp from '../core/ui/app.js';
import DevMode from '../search/ui/search_ui_devmode.js';
import PiecePlace from '../search/ui/piece_place_switch.js';
import Query from '../search/ui/search_ui_query.js';
import Search from '../search/search.js';
import Cookies from 'universal-cookie';
import AppDrawer from './ui/app_drawer.js';

const styles = theme => ({
  logo :{
    padding: 0,
    margin: 0,
    width: 80,
    marginRight: 10,
  },
  query :{
    width: '100%',
    display: 'block',
  },
  devMode :{
    float: 'right',
    display: 'block',
    paddingLeft: 10,
  },
});

const cookie = new Cookies();


class SearchApp extends React.Component {
  constructor(props,context) {
    super(props,context);
    const dev = cookie.get('dev');
    const piece = (cookie.get('piece')) ? cookie.get('piece') : 'true';
    this.state = {
      loading: false,
      results: null, 
      devMode: (dev === 'true') ? true : false,
      piecePlaceSwitch: (piece === 'true') ? true : false,
      q: '',
      q_res: '',
      p: 1,
      message: '',
    }

    this.querybox = null;

    this.api = window.__api;
    this.setDevMode = this.setDevMode.bind(this);
    this.setPiecePlace = this.setPiecePlace.bind(this);
    this.doSearch = this.doSearch.bind(this);
    this.search = this.search.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.fetch = this.fetch.bind(this); 
  }

  setDevMode(checked){
    this.setState({ devMode: checked }, function(){
      cookie.set('dev', checked);
    });  
  }

  setPiecePlace(checked){
    this.setState({ piecePlaceSwitch: checked }, function(){
      cookie.set('piece', checked);
    });  
  }

  doSearch(event) {
    const q = event.target.value;
    if(this.state.q !== q){
      this.props.router.push('/?q=' + encodeURIComponent(q)); 
    }
  }

  loadMore(callback){
    const $this = this;
    this.setState({p: this.state.p + 1}, function(){
      $this.fetch()
      .then(response => {
        callback();  
      });
      
    });       
  }

  search(q) {
    if(!q) return;
    
    if(q === ''){
      this.setState({results: null, p:1, q: '', q_res: ''});
      return;  
    } 

    if(this.state.q === q){
      return;
    }
    if(this.querybox){
      this.querybox.setText(q);
    }

    this.setState({q: q, results: null, p:1}, function(){this.fetch()});
  }
  
  componentDidUpdate(prevProps) {
    this.search(this.props.router.location.query.q);
  }

  componentWillMount(){
    if(this.props.router.location.query.q){
      this.search(this.props.router.location.query.q);
    }
  }

  fetch(){
    const $this = this;
    return new Promise((resolve, reject) =>{
      $this.api.getResults($this.state.q, $this.state.p, false, $this.props.src)
      .then(data=>{
        if($this.state.results == null){
          $this.setState({q_res: $this.state.q, results: data});
        } else {
          data = data.items;
          var arr = $this.state.results.items.slice();
          for(var i = 0; data && i < data.length; i++){
            arr.push(data[i]);
          }
          $this.state.results.items = arr;
          $this.setState({q_res: $this.state.q, results: $this.state.results});
          resolve();
        }
      });      
    });
  }

  render(){
    var key = 0;
    const classes = this.props.classes;   
    const toolbar = [];
    toolbar.push(<div key={key++} className={classes.query}><Query value={this.state.q} onChange={this.doSearch} server={this.api.server} onRef={(ref) => {this.querybox = ref;}}/></div>);
    var devSwitch = <DevMode checked={this.state.devMode} onChange={this.setDevMode}/>;    
    var pieceSwitch = <PiecePlace checked={this.state.piecePlaceSwitch} onChange={this.setPiecePlace}/>;    
    const options = [devSwitch, pieceSwitch];
    const menu = [];
    const logo = {src:'./res/logo.png', className:classes.logo};
    const appbar = {logo: logo, menu : menu, toolbar: toolbar};

    return(     
      <UIApp title={'Search'} toolbar={appbar.toolbar} menu={appbar.menu} server={this.api.server} drawer={<AppDrawer options={options}/>}>
        <Search results={this.state.results} uiOptions={{devMode: this.state.devMode, piecePlace: this.state.piecePlaceSwitch}} devMode={this.state.devMode} onLoadMore={this.loadMore} server={this.api.server}/>
      </UIApp>        
    );
  }
}

withRouter(SearchApp);
export default withStyles(styles)(SearchApp);


// WEBPACK FOOTER //
// ./src/search/search_app.js